import './../stylesheets/workers';

import * as kenAllComponent from './components/ken_all';
import * as ruleFieldComponent from './components/rule_field';
import * as fieldComponent from './components/field';
import * as fileFieldComponent from './components/file_field';
import * as callapseComponent from './components/collapse';
import * as canpanComponent from './components/canpan';
import * as formComponent from './components/form';

// ページ読み込み時の処理
document.addEventListener('turbolinks:load', function() {
  // 住所のアクション
  kenAllComponent.setAdrresEvent();
  // 定款上の活動分野のアクション
  ruleFieldComponent.fieldCustom();
  // 分野のアクション
  fieldComponent.fieldAllSelect();
  fieldComponent.fieldAllRelease();
  fieldComponent.fieldCustom();
  // ファイルフィールドのアクション
  fileFieldComponent.selectFileFieldActions();
  fileFieldComponent.selectFileAfterActions();
  fileFieldComponent.cancelSelectFile();
  fileFieldComponent.destroySelectFile();
  // アコーディオンのアクション
  callapseComponent.toggleCollapse();
  // canpanのアクション
  canpanComponent.syncAffiliationData();
  canpanComponent.getIcondata();
  // フォームのアクション
  formComponent.temporarilySave();
})